<app-reactive-dialog-content [data]="dialogInputData">

  <div class="outer">
    Haben Sie den Kunden über das Kundenportal informiert?
  </div>

  <app-spacer></app-spacer>
  <div class="button-container">
    <button mat-raised-button color="accent" class="main button-right-margin" (click)="onConfirm(true)">JA</button>
    <button mat-raised-button color="accent" class="main button-right-margin" (click)="onConfirm(false)">NEIN</button>
    <button mat-icon-button (click)="showInfoDialog()" class="button-left-margin" matTooltip="Details anzeigen"
            type="button">
      <mat-icon color="primary">help</mat-icon>
    </button>
  </div>
</app-reactive-dialog-content>
